<template>
    <CrmConnectionPendingFinal />
</template>

<script>
import CrmConnectionPendingFinal from '@/components/project/onBoarding/CrmConnectionPendingFinal.vue'

export default {
    name: 'AuthorizationPending',
    components: { CrmConnectionPendingFinal },
}
</script>
